/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {settleTransaction} from '../api'

export const useMutationSettleTransaction = createReactQueryMutationHook('settleTransaction', settleTransaction)
